import moment from "moment";
import { eventsType } from "../utils";
import { getLocalizedString } from "../../../shared/translation";
import { VideoEvidenceButton } from "../Shared/Button";

const getEventTypeStatus = (events) => {
  if (events?.status && events?.sub_type && events?.status !== events?.sub_type) {
    if (events?.type === "speeding") {
      return eventsType(events?.status);
    }
    return eventsType(events?.sub_type) + "-" + eventsType(events?.status);
  } else if (events?.status) {
    return eventsType(events?.status);
  } else if (events?.sub_type) {
    return eventsType(events?.sub_type);
  } else return "";
};

const formatCoordinates = (lat, lng) => {
  if (!lat || !lng) return "NA";
  return `${Number(lat).toFixed(5)},${Number(lng).toFixed(5)}`;
};

const getLocationDisplay = (address, lat, lng) => {
  return address || formatCoordinates(lat, lng);
};

const getEventTime = (events) => {
  if (events?.type === "geofence") {
    if (events?.status === "exit") return events?.exit_time;
    if (events?.status === "entry") return events?.entry_time;
    if (events?.sub_type === "time limit exceeded") return events?.start_time;
  }
  if (events?.sub_type === "geofence" && events?.type === "speeding") {
    return events?.start_time;
  }
  return null;
};

export const header = [
  {
    label: getLocalizedString("time", "Time"),
    id: 1,
    nestedValue: true,
    getNestedValue: ({ source_time, events }) => {
      const time = getEventTime(events) || source_time;
      const formattedTime = time ? formatTime(time) : "";
      return <h1 title={formattedTime}>{formattedTime}</h1>;
    },
  },
  {
    label: getLocalizedString("type", "Type"),
    id: 2,
    nestedValue: true,
    getNestedValue: ({ events }) => {
      return <h1 title={eventsType(events?.type)}>{eventsType(events?.type, events?.sub_type)}</h1>;
    },
  },
  {
    label: getLocalizedString("name", "Name"),
    id: 3,
    nestedValue: true,
    getNestedValue: ({ events, activities }) => {
      const name =
        events?.config?.name ||
        events?.config?.Config?.name ||
        activities?.data?.config?.Config?.name ||
        activities?.data?.config?.name;
      return <h1 title={name}>{name}</h1>;
    },
  },
  {
    label: "Location",
    id: 4,
    nestedValue: true,
    getNestedValue: ({ gps, events }) => {
      let lat, lng, address;

      if (events?.type === "geofence" && ["exit", "entry"].includes(events?.status)) {
        const positionType = events.status === "entry" ? "entry_position" : "exit_position";
        lat = events[positionType]?.lat;
        lng = events[positionType]?.lng;
        address = events[positionType]?.address?.name;
      } else {
        lat = gps?.position?.lat;
        lng = gps?.position?.lng;
        address = gps?.position?.address?.name;
      }
      if (events?.type === "geofence" && events?.sub_type === "time limit exceeded") {
        lat = events?.start_position?.lat;
        lng = events?.start_position?.lng;
        address = events?.start_position?.address?.name;
      }

      const locationText = getLocationDisplay(address, lat, lng);
      return <h1 title={locationText}>{locationText}</h1>;
    },
  },
  // {
  //   label: "Lat",
  //   id: 5,
  //   nestedValue: true,
  //   getNestedValue: ({ gps }) => {
  //     const lat = gps?.position?.lat;
  //     return <h1>{lat ? Number(lat).toFixed(5) : "NA"}</h1>;
  //   },
  // },
  // {
  //   label: "Lng",
  //   id: 6,
  //   nestedValue: true,
  //   getNestedValue: ({ gps }) => {
  //     const lng = gps?.position?.lng;
  //     return <h1>{lng ? Number(lng).toFixed(5) : "NA"}</h1>;
  //   },
  // },
  {
    label: getLocalizedString("status", "Status"),
    id: 5,
    nestedValue: true,
    getNestedValue: ({ events }) => {
      return <h1 title={getEventTypeStatus(events)}>{getEventTypeStatus(events)}</h1>;
    },
  },
  {
    label: '',
    id: 6,
    nestedValue: true,
    getNestedValue: ({ events, plate_number, source_time}) => {
      if (events?.config.video_evidence) {
        return (
          <VideoEvidenceButton
            plateNumber={plate_number}
            sourceTime={source_time}
            wrapperClassName="top-1"
            btnClassName="sm"
            tooltipPosition="right"
          />
        )
      }

      return <></>;
    },
  }
];

function formatTime(time) {
  return moment(time).format("DD/MM/YY - hh:mm:ss A");
}
